function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
/* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Translate, t } from "../../../../../I18N";
import { Button, Card, Sidepanel } from "../../../../Components/UI";
import { Checkbox } from "../../../../Components/Forms";
import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';








const Header = ({ label, total }) => /*#__PURE__*/
_jsx("div", { className: "flex items-center space-x-2 text-indigo-700" }, void 0, /*#__PURE__*/
_jsx("div", { className: "flex-none" }, void 0, label), /*#__PURE__*/
_jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
_jsx("div", { className: "flex-none" }, void 0, total)
);


const getPercentage = (match, total) => {
  const percentage = match / total * 100;

  if (Number.isNaN(percentage)) {
    return '-';
  }

  return `${Math.round(percentage)}%`;
};

const FiltersSidepanel = ({
  showSidepanel,
  setShowSidepanel,
  aggregation
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultFilter = {
    labeled: {
      match: false,
      mismatch: false
    },
    nonLabeled: {
      noContext: false,
      noSuggestion: false,
      obsolete: false,
      others: false
    }
  };

  let initialFilters = defaultFilter;

  try {
    if (searchParams.has('filter')) {
      initialFilters = JSON.parse(searchParams.get('filter'));
    }
  } catch (e) {}

  const { register, handleSubmit, reset, setValue } = useForm({
    values: initialFilters,
    defaultValues: defaultFilter
  });

  const submitFilters = async (filters) => {
    setSearchParams((prev) => {
      prev.set('page', '1');
      prev.set('filter', JSON.stringify(filters));
      return prev;
    });
    setShowSidepanel(false);
  };

  const checkOption = (e, optionName) => {
    const { checked } = e.target;
    setValue(optionName, checked);
  };

  const clearFilters = () => {
    setSearchParams((prev) => {
      prev.delete('filter');
      return prev;
    });
    setShowSidepanel(false);
    reset();
  };

  return /*#__PURE__*/(
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      closeSidepanelFunction: () => setShowSidepanel(false),
      title: /*#__PURE__*/
      _jsx("span", { className: "text-base font-semibold uppercase" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Stats & Filters")
      ) }, void 0, /*#__PURE__*/


    _jsx("form", { onSubmit: handleSubmit(submitFilters), className: "flex flex-col h-full" }, void 0, /*#__PURE__*/
    _jsx(Sidepanel.Body, { className: "flex flex-col flex-grow gap-4" }, void 0, /*#__PURE__*/
    _jsx(Card, {
      title: /*#__PURE__*/_jsx(Header, { label: t('System', 'Labeled'), total: aggregation.labeled._count }) }, void 0, /*#__PURE__*/

    _jsx("div", { className: "mx-4 mb-3 space-y-1 text-black" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1 bg-green-200" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex-none" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Accuracy")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono" }, void 0,
    getPercentage(aggregation.labeled.match, aggregation.labeled._count)
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: "Match" },
    register('labeled.match'), {
      onChange: (e) => {
        checkOption(e, 'labeled.match');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none" }, void 0, aggregation.labeled.match)
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: "Mismatch" },
    register('labeled.mismatch'), {
      onChange: (e) => {
        checkOption(e, 'labeled.mismatch');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none" }, void 0, aggregation.labeled.mismatch)
    )
    )
    ), /*#__PURE__*/
    _jsx(Card, {
      title: /*#__PURE__*/
      _jsx(Header, { label: t('System', 'Non-labeled'), total: aggregation.nonLabeled._count }) }, void 0, /*#__PURE__*/


    _jsx("div", { className: "mx-4 mb-3 space-y-1" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1 bg-yellow-100" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex-none" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Pending")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none font-mono" }, void 0,
    getPercentage(aggregation.nonLabeled._count, aggregation.total)
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: "No suggestion" },
    register('nonLabeled.noSuggestion'), {
      onChange: (e) => {
        checkOption(e, 'nonLabeled.noSuggestion');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none" }, void 0, aggregation.nonLabeled.noSuggestion)
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: "No context" },
    register('nonLabeled.noContext'), {
      onChange: (e) => {
        checkOption(e, 'nonLabeled.noContext');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none" }, void 0, aggregation.nonLabeled.noContext)
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: "Obsolete" },
    register('nonLabeled.obsolete'), {
      onChange: (e) => {
        checkOption(e, 'nonLabeled.obsolete');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none" }, void 0, aggregation.nonLabeled.obsolete)
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center space-x-1" }, void 0, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: "Others" },
    register('nonLabeled.others'), {
      onChange: (e) => {
        checkOption(e, 'nonLabeled.others');
      } })
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 border-t border-dashed border-t-gray-200" }), /*#__PURE__*/
    _jsx("div", { className: "flex-none" }, void 0, aggregation.nonLabeled.others)
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { className: "flex-grow", type: "button", styling: "outline", onClick: clearFilters }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Clear all")
    ), /*#__PURE__*/
    _jsx(Button, { className: "flex-grow", type: "submit" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Apply")
    )
    )
    )
    )
    ));

};

export { FiltersSidepanel };